import React, {useContext} from 'react';

const ChildContext = React.createContext(null);

export default ChildContext;

export const useChildContext = () =>  useContext(ChildContext) ;